
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'oxd-card-tbody',

  computed: {
    classes(): object {
      return {
        'oxd-table-body': true,
      };
    },
  },
});
